import { fetchUtils } from 'react-admin';
import { tenantService } from '../../services/tenantService';
import type { FormDefinition } from './types';

const baseUrl = import.meta.env.VITE_SIMPLE_REST_URL as string;

function buildAuthHeaders(): Headers {
  const headers = new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
  });
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }
  const tenantCode = tenantService.getCurrentTenantCode();
  headers.set('x-tenant-code', tenantCode);
  return headers;
}

export async function generateFormWithAI(prompt: string): Promise<FormDefinition> {
  if (!prompt || !prompt.trim()) {
    throw new Error('Prompt is required');
  }

  const url = `${baseUrl}/forms/generate-with-ai`;

  try {
    const { json } = await fetchUtils.fetchJson(url, {
      method: 'POST',
      headers: buildAuthHeaders(),
      body: JSON.stringify({ prompt }),
    });

    const formDefinition = json as FormDefinition;

    if (!formDefinition || typeof formDefinition !== 'object') {
      throw new Error('Invalid form definition structure: not an object');
    }
    if (!Array.isArray(formDefinition.fields)) {
      throw new Error('Invalid form definition structure: fields must be an array');
    }

    formDefinition.fields = formDefinition.fields.map((field) => {
      if (field.type === 'EquipmentLookup' && !field.filter) {
        return { ...field, filter: '{"type":"Other"}' };
      }
      return field;
    });

    return formDefinition;
  } catch (error: unknown) {
    const err = error as { body?: string; message?: string };
    if (err?.body) {
      try {
        const errorData =
          typeof err.body === 'string' ? JSON.parse(err.body) : err.body;
        const msg =
          (errorData as { message?: string }).message ||
          (errorData as { error?: string }).error;
        throw new Error(msg || 'Failed to generate form');
      } catch {
        throw new Error(typeof err.body === 'string' ? err.body : 'Failed to generate form');
      }
    }
    if (error instanceof Error) throw error;
    throw new Error(`Failed to generate form: ${String(error)}`);
  }
}
